import React, { useState } from 'react';
import CompanyName from '../../commonComponents/CompanyName';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { DateType } from '../../../static/types/commonTypes/dateType';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import { IndividualWithFamilySituationType } from '../../../static/types/commonTypes/individualWithFamilySituationType';
import { MariageContractType } from '../../../static/types/commonTypes/mariageContractType';
import MariageContract from '../../commonComponents/MariageContract';
import DateComponent from '../../commonComponents/DateComponent';
import DateOfBirthAndCityComponent from '../../commonComponents/DateOfBirthAndCity';
import { DateOfBirthAndCityType } from '../../../static/types/commonTypes/dateOfBirthAndCity';
import { HeadOfficeAddressType } from '../../../static/types/commonTypes/headOfficeAddressType';
import { PreviousMaritalRegimeType } from '../../../static/types/commonTypes/previousMaritalRegimeType';
import { IndividualPersonType } from '../../../static/types/commonTypes/individualType';
import IndividualWithProfession from '../../commonComponents/IndividualWithProfession';
import HeadOfficeAddress from '../../commonComponents/HeadOfficeAddress';
import MeritalRegime from '../../commonComponents/MaritalRegime';
import IndividualPerson from '../../commonComponents/IndividualPerson';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const ChangementRegimeMatrimonial: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        registrationReference, setRegistrationReference,
        registrationReferenceValidity, setRegistrationReferenceValidity,
        registrationReferenceChecked, setRegistrationReferenceChecked,

        notaryContact, setNotaryContact,
        notaryContactValidity, setNotaryContactValidity,
        notaryContactChecked, setNotaryContactChecked,

        applicant, setApplicant,
        applicantValidity, setApplicantValidity,
        applicantChecked, setApplicantChecked,

        mariageContract, setMariageContract,

        reducedIndividualPerson, setReducedIndividualPerson,
        reducedIndividualPersonValidity, setReducedIndividualPersonValidity,
        reducedIndividualPersonChecked, setReducedIndividualPersonChecked,

        residentialAddress, setResidentialAddress,
        residentialAddressValidity, setResidentialAddressValidity,
        residentialAddressChecked, setResidentialAddressChecked,

        mainResidenceAddress, setMainResidenceAddress,
        mainResidenceAddressValidity, setMainResidenceAddressValidity,
        mainResidenceAddressChecked, setMainResidenceAddressChecked,

        spouseNumberOne, setSpouseNumberOne,
        spouseNumberOneValidity, setSpouseNumberOneValidity,
        spouseNumberOneChecked, setSpouseNumberOneChecked,

        spouseOneBirth, setSpouseOneBirth,
        spouseOneBirthValidity, setSpouseOneBirthValidity,
        spouseOneBirthChecked, setSpouseOneBirthChecked,

        spouseNumberTwo, setSpouseNumberTwo,
        spouseNumberTwoValidity, setSpouseNumberTwoValidity,
        spouseNumberTwoChecked, setSpouseNumberTwoChecked,

        spouseTwoBirth, setSpouseTwoBirth,
        spouseTwoBirthValidity, setSpouseTwoBirthValidity,
        spouseTwoBirthChecked, setSpouseTwoBirthChecked,

        spousesAddress, setSpousesAddress,
        spousesAddressValidity, setSpousesAddressValidity,
        spousesAddressChecked, setSpousesAddressChecked,

        previousRegime, setPreviousRegime,
        previousRegimeValidity, setPreviousRegimeValidity,
        previousRegimeChecked, setPreviousRegimeChecked,

        newRegime, setNewRegime,

        typeNotaryData, setTypeNotaryData,

        contractDate, setcontractDate,

        officiatingNotary, setOfficiatingNotary,
        officiatingNotaryValidity, setOfficiatingNotaryValidity,
        officiatingNotaryChecked, setOfficiatingNotaryChecked,

        oppositionsNotary, setOppositionsNotary,
        oppositionsNotaryValidity, setOppositionsNotaryValidity,
        oppositionsNotaryChecked, setOppositionsNotaryChecked,

        deathDate, setDeathDate

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState(false)

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const acteText = `Suivant acte reçu${contractDate.date && ` le ${contractDate.date}`} par ${officiatingNotary.civility === "Monsieur" ? 'M.' : 'Mme'} ${officiatingNotary.lastName} ${officiatingNotary.firstName}, ${officiatingNotary.address}${officiatingNotary.additionalAddress && officiatingNotary.additionalAddress} ${officiatingNotary.postalCode} ${officiatingNotary.city}`

            const spouseOneText = `${spouseNumberOne.civility === "Monsieur" ? 'M.' : 'Mme'} ${spouseNumberOne.lastName} ${spouseNumberOne.firstName} de nationalité ${spouseNumberOne.nationality}, ${spouseNumberOne.civility === "Monsieur" ? 'né' : 'née'} ${spouseNumberOne.birthName} le ${spouseOneBirth.dateOfBirth} à ${spouseOneBirth.city}`

            const spouseTwoText = `${spouseNumberTwo.civility === "Monsieur" ? 'M.' : 'Mme'} ${spouseNumberTwo.lastName} ${spouseNumberTwo.firstName} de nationalité ${spouseNumberTwo.nationality}, ${spouseNumberTwo.civility === "Monsieur" ? 'né' : 'née'} ${spouseNumberTwo.birthName} le ${spouseTwoBirth.dateOfBirth} à ${spouseTwoBirth.city}, son ${spouseNumberTwo.civility === "Monsieur" ? 'époux' : 'épouse'}`

            const spousesAddressText = `demeurant ensemble à ${spousesAddress.address}${spousesAddress.additionalAddress ? `${spousesAddress.additionalAddress}` : ''} ${spousesAddress.postalCode} ${spousesAddress.city}`

            const mariageContractText = showMariageContract
                ? ` aux termes du contrat de mariage ${(mariageContract.editDate || mariageContract.editor) && 'reçu'}${mariageContract.editDate ? ` le ${mariageContract.editDate}` : ''}${mariageContract.editor ? ` par Maitre ${mariageContract.editor}` : ''}${mariageContract.editPlace ? `, notaire à ${mariageContract.editPlace}` : ''}`
                : ''

            const previousRegimeText = `Mariés à ${previousRegime.weddingPlace} le ${previousRegime.weddingDate} sous le régime de la ${previousRegime.previousRegime.toLowerCase()}`

            const newRegimeText = `ont expressément déclaré adopter le régime de ${newRegime.toLowerCase()}`

            const oppositionsText = typeNotaryData === 1
                ? `Les oppositions des créanciers à ce changement, s'il y a lieu, seront reçues dans les trois mois de la présente insertion, en l'office notarial de ${oppositionsNotary.civility === "Monsieur" ? 'M.' : 'Mme'} ${oppositionsNotary.lastName} ${oppositionsNotary.firstName}, ${oppositionsNotary.address}${oppositionsNotary.additionalAddress && oppositionsNotary.additionalAddress} ${oppositionsNotary.postalCode} ${oppositionsNotary.city}.`
                : `Les oppositions des créanciers à ce changement, s'il y a lieu, seront reçues dans les trois mois de la présente insertion, en l'office notarial de ${officiatingNotary.civility === "Monsieur" ? 'M.' : 'Mme'} ${officiatingNotary.lastName} ${officiatingNotary.firstName}.`

            const tempText = `${acteText}, ${spouseOneText}, et ${spouseTwoText}, ${spousesAddressText}. ${previousRegimeText}${mariageContractText}, ${newRegimeText}.
${oppositionsText}`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
            setSubmissive(true);
        }
    };

    const validate = () => {
        if (!companyNameValidity) setActiveTab('companyName')
        else if (!(spouseNumberOneValidity && spouseOneBirthValidity)) setActiveTab('spouseNumberOne')
        else if (!(spouseNumberTwoValidity && spouseTwoBirthValidity)) setActiveTab('spouseNumberTwo')
        else if (!spousesAddressValidity) setActiveTab('spousesAddress')
        else if (!previousRegimeValidity) setActiveTab('previousMaritalRegime')
        else if (!officiatingNotaryValidity) setActiveTab('newMaritalRegime')
        else if (typeNotaryData !== 0 && !oppositionsNotaryValidity) setActiveTab('notary')

        const spouseOneValidity = spouseNumberOneValidity && spouseOneBirthValidity
        const spouseTwoValidity = spouseNumberTwoValidity && spouseTwoBirthValidity
        const notaryValidity = typeNotaryData === 0 ? true : oppositionsNotaryValidity

        return companyNameValidity && spouseOneValidity && spouseTwoValidity && spousesAddressValidity && officiatingNotaryValidity && notaryValidity
    }

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleNext = () => {
        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) switchTab(getNextTab('companyName'))
        }
        else if (activeTab === 'spouseNumberOne') {
            setSpouseNumberOneChecked(true)
            setSpouseOneBirthChecked(true)
            if (spouseNumberOneValidity && spouseOneBirthValidity) switchTab(getNextTab('spouseNumberOne'))
        }
        else if (activeTab === 'spouseNumberTwo') {
            setSpouseNumberTwoChecked(true)
            setSpouseTwoBirthChecked(true)
            if (spouseNumberTwoValidity && spouseTwoBirthValidity) switchTab(getNextTab('spouseNumberTwo'))
        }
        else if (activeTab === 'spousesAddress') {
            setSpousesAddressChecked(true)
            if (spousesAddressValidity) switchTab(getNextTab('spousesAddress'))
        }
        else if (activeTab === 'previousMaritalRegime') {
            setPreviousRegimeChecked(true)
            if (previousRegimeValidity) switchTab(getNextTab('previousMaritalRegime'))
        }
        else if (activeTab === 'mariageContract') {
            switchTab(getNextTab('mariageContract'))
        }
        else if (activeTab === 'newMaritalRegime') {
            setOfficiatingNotaryChecked(true)
            if (officiatingNotaryValidity) switchTab(getNextTab('newMaritalRegime'))
        }
        else if (activeTab === 'mariageContractDate') {
            switchTab(getNextTab('mariageContractDate'))
        }
        else if (activeTab === 'notary') {
            if (typeNotaryData !== 0) {
                setOppositionsNotaryChecked(true)
                if (oppositionsNotaryValidity) setSubmissive(true)
            }
            else setSubmissive(true)
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false)
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === 'companyName') return 'spouseNumberOne';
        else if (currentTab === 'spouseNumberOne') return 'spouseNumberTwo';
        else if (currentTab === 'spouseNumberTwo') return 'spousesAddress';
        else if (currentTab === 'spousesAddress') return 'previousMaritalRegime';
        else if (currentTab === 'previousMaritalRegime') {
            if (showMariageContract) return 'mariageContract'
            else return 'newMaritalRegime'
        }
        else if (currentTab === 'mariageContract') return 'newMaritalRegime'
        else if (currentTab === 'newMaritalRegime') return 'mariageContractDate'
        else if (currentTab === 'mariageContractDate') return 'notary'
        else return currentTab
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === 'spouseNumberOne') return 'companyName';
        else if (currentTab === 'spouseNumberTwo') return 'spouseNumberOne';
        else if (currentTab === 'spousesAddress') return 'spouseNumberTwo';
        else if (currentTab === 'previousMaritalRegime') return 'spousesAddress';
        else if (currentTab === 'mariageContract') return 'previousMaritalRegime';
        else if (currentTab === 'newMaritalRegime') {
            if (showMariageContract) return 'mariageContract'
            else return 'previousMaritalRegime'
        }
        else if (currentTab === 'mariageContractDate') return 'newMaritalRegime'
        else if (currentTab === 'notary') return 'mariageContractDate'
        else return currentTab
    };

    const goToSupportPresse = () => { updateActiveIndex(2); }

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateSpouseOne = (data: Partial<IndividualWithFamilySituationType>) => setSpouseNumberOne({ ...spouseNumberOne, ...data });
    const updateSpouseOneBirth = (data: Partial<DateOfBirthAndCityType>) => setSpouseOneBirth({ ...spouseOneBirth, ...data });

    const updateSpouseTwo = (data: Partial<IndividualWithFamilySituationType>) => setSpouseNumberTwo({ ...spouseNumberTwo, ...data });
    const updateSpouseTwoBirth = (data: Partial<DateOfBirthAndCityType>) => setSpouseTwoBirth({ ...spouseTwoBirth, ...data });

    const updateSpousesAddress = (data: Partial<HeadOfficeAddressType>) => setSpousesAddress({ ...spousesAddress, ...data });

    const updatePreviousRegime = (partialData: Partial<PreviousMaritalRegimeType>) => setPreviousRegime({ ...previousRegime, ...partialData });

    const updateMariageContract = (data: Partial<MariageContractType>) => setMariageContract({ ...mariageContract, ...data });

    const updateOfficiatingNotary = (data: Partial<IndividualPersonType>) => setOfficiatingNotary({ ...officiatingNotary, ...data });

    const updateOppositionsNotary = (data: Partial<IndividualPersonType>) => setOppositionsNotary({ ...oppositionsNotary, ...data });

    const updateMariageContractDate = (data: Partial<DateType>) => setcontractDate({ ...deathDate, ...data });

    const showMariageContract = previousRegime.previousRegime !== "Communauté de biens réduite aux acquêts"

    const tabs = [
  { key: 'companyName', label: 'Raison Sociale' },
  { key: 'spouseNumberOne', label: 'État civil époux n°1' },
  { key: 'spouseNumberTwo', label: 'État civil époux n°2' },
  { key: 'spousesAddress', label: 'Coordonnées des époux' },
  { key: 'previousMaritalRegime', label: 'Mariage et ancien régime matrimonial' },
];

if (showMariageContract) {
  tabs.push({ key: 'mariageContract', label: 'Contrat de mariage' });
}

tabs.push(
  { key: 'newMaritalRegime', label: 'Nouveau régime matrimonial' },
  { key: 'mariageContractDate', label: 'Contrat de mariage' },
  { key: 'notary', label: 'Notaire recevant les oppositions' }
);
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'spouseNumberOne' &&
                    <>
                        <IndividualWithProfession
                            changeIndividual={updateSpouseOne}
                            checked={spouseNumberOneChecked}
                            individual={spouseNumberOne}
                            onValidationChange={(isValid: boolean) => setSpouseNumberOneValidity(isValid)}
                        />

                        <div className="mb-3 row">
                            <div className="col-sm-12 p-2 title">
                                <span className="text-white"> Date et lieu de naissance </span>
                            </div>
                        </div>

                        <DateOfBirthAndCityComponent
                            checked={spouseOneBirthChecked}
                            dateOfBirth={spouseOneBirth}
                            onChange={updateSpouseOneBirth}
                            onValidationChange={(isValid: boolean) => setSpouseOneBirthValidity(isValid)}
                        />
                    </>
                }

                {
                    activeTab === 'spouseNumberTwo' &&
                    <>
                        <IndividualWithProfession
                            changeIndividual={updateSpouseTwo}
                            checked={spouseNumberTwoChecked}
                            individual={spouseNumberTwo}
                            onValidationChange={(isValid: boolean) => setSpouseNumberTwoValidity(isValid)}
                        />

                        <div className="mb-3 row">
                            <div className="col-sm-12 p-2 title">
                                <span className="text-white"> Date et lieu de naissance </span>
                            </div>
                        </div>

                        <DateOfBirthAndCityComponent
                            checked={spouseTwoBirthChecked}
                            dateOfBirth={spouseTwoBirth}
                            onChange={updateSpouseTwoBirth}
                            onValidationChange={(isValid: boolean) => setSpouseTwoBirthValidity(isValid)}
                        />
                    </>
                }

                {
                    activeTab === 'spousesAddress' &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateSpousesAddress}
                        checked={spousesAddressChecked}
                        headOfficeAddress={spousesAddress}
                        onValidationChange={(isValid: boolean) => setSpousesAddressValidity(isValid)}
                    />
                }

                {
                    activeTab === 'previousMaritalRegime' &&
                    <MeritalRegime
                        changeMaritalRegime={updatePreviousRegime}
                        checked={previousRegimeChecked}
                        maritalRegime={previousRegime}
                        onValidationChange={(isValid: boolean) => setPreviousRegimeValidity(isValid)}
                    />
                }

                {
                    activeTab === 'mariageContract' &&
                    showMariageContract &&
                    <MariageContract
                        changeMariageContract={updateMariageContract}
                        mariageContract={mariageContract}
                    />
                }

                {
                    activeTab === 'newMaritalRegime' &&
                    <>

                        <div className="mb-3 row">

                            <label htmlFor="newRegime" className="col-sm-2 col-form-label">Nouveau régime <strong className="text-danger">*</strong> </label>

                            <div className="col-sm-10">
                                <select
                                    className='form-select'
                                    name="newRegime"
                                    id="newRegime"
                                    onChange={event => setNewRegime(event.target.value)}
                                    value={newRegime}
                                >
                                    {
                                        [
                                            "Communauté de biens réduite aux acquêts",
                                            "Séparation de biens",
                                            "Communauté universelle",
                                            "Participation aux acquêts"
                                        ].map((regime, key) =>
                                            <option key={key} value={regime}>
                                                {regime}
                                            </option>
                                        )
                                    }
                                </select>

                            </div>

                        </div>

                        <div className="mb-3 row">
                            <div className="col-sm-12 p-2 title">
                                <span className="text-white">  officiant </span>
                            </div>
                        </div>

                        <IndividualPerson
                            changeIndividual={updateOfficiatingNotary}
                            checked={officiatingNotaryChecked}
                            individual={officiatingNotary}
                            onValidationChange={(isValid: boolean) => setOfficiatingNotaryValidity(isValid)}
                            draftFieldName = 'officiatingNotary'
                        />
                    </>
                }

                {
                    activeTab === 'mariageContractDate' &&
                    <DateComponent
                        changeDate={updateMariageContractDate}
                        date={contractDate}
                        draftFieldName = 'contractDate'
                        dateLabel='Date du contrat'
                        required={false}
                        id='contractDate'
                    />
                }

                {
                    activeTab === "notary" &&
                    <>
                        <div className="mb-3 row">

                            <label htmlFor="notary" className="col-sm-2 col-form-label"> Notaire </label>

                            <div className="col-sm-10">
                                <select
                                    className='form-select'
                                    name="notary"
                                    id="notary"
                                    onChange={event => setTypeNotaryData(Number(event.target.value))}
                                    value={Number(typeNotaryData)}
                                >
                                    <option value={0}> Même notaire officiant </option>
                                    <option value={1}> Notaire différent du notaire officiant </option>
                                </select>

                            </div>

                        </div>
                        {
                            typeNotaryData === 1 &&
                            <IndividualPerson
                                changeIndividual={updateOppositionsNotary}
                                checked={oppositionsNotaryChecked}
                                individual={oppositionsNotary}
                                onValidationChange={(isValid: boolean) => setOppositionsNotaryValidity(isValid)}
                                draftFieldName = 'oppositionsNotary'
                            />
                        }
                    </>
                }

                {
                    submissive &&
                    activeTab === 'notary' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'notary' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'notary' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'notary' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default ChangementRegimeMatrimonial;